import { Component } from "@angular/core";
import { cl } from "@fullcalendar/core/internal-common";
import { WhitelabelService } from "../core/services/whitelabel.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Component({
    selector: 'BTA-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
})

export class HomePageComponent {

    public imageUrl = environment?.imageUrl;
    htmlContent: SafeHtml | null = null;
    loading = false;
    isStaticContent = false;

    // Rendered twice in the template so the CSS marquee can loop seamlessly -
    // the track scrolls exactly -50% and lands back where it started.
    readonly airlines = [
        { name: 'Air India', src: 'assets/images/home/airlines/air-india.svg' },
        { name: 'IndiGo', src: 'assets/images/home/airlines/indigo.svg' },
        { name: 'Emirates', src: 'assets/images/home/airlines/emirates.svg' },
        { name: 'Lufthansa', src: 'assets/images/home/airlines/lufthansa.svg' },
        { name: 'British Airways', src: 'assets/images/home/airlines/british-airways.svg' },
        { name: 'Qatar Airways', src: 'assets/images/home/airlines/qatar-airways.svg' },
        { name: 'Singapore Airlines', src: 'assets/images/home/airlines/singapore-airlines.svg' },
        { name: 'Turkish Airlines', src: 'assets/images/home/airlines/turkish-airlines.svg' },
        { name: 'Air France', src: 'assets/images/home/airlines/air-france.svg' },
        { name: 'Etihad Airways', src: 'assets/images/home/airlines/etihad.svg' },
    ];

    constructor(private api: WhitelabelService, private sanitizer: DomSanitizer, private router: Router) { }


    ngOnInit() {
        this.loading = true;
        this.api.getPageContent({ path: this.router.url }).subscribe({
            next: (res: any) => {
                if (res?.static) {
                    this.isStaticContent = true;
                    this.loadHtmlContent(res?.html);
                }
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    loadHtmlContent(html) {
        this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(html);
    }
}